<template>
    <div class="vx-notification-dropdown mt-2 mr-2">
        <vx-dropdown :justify="justify" :align="align" openOnClick>
            <div class="notification">
                <vx-basic-icon icon="BellIcon" />
                <vs-chip color="danger" :class="chipClass" v-if="hasNewNotification">
                    {{ showNotificationCounter ? newNotificationCount : '' }}
                </vs-chip>
            </div>
            <template slot="menu">
                <vx-scroll-area preventScrollX class="scroll-area">
                    <div v-if="!hasNotifications">
                        <vx-spinner :scale="0.6"></vx-spinner>
                    </div>
                    <transition-group name="list" appear tag="div">
                        <div v-for="notification in notifications" :key="notification.id">
                            <div v-if="isItemArray(notification)">
                                <notification-group-item :notifications="notification" />
                            </div>
                            <template v-else>
                                <notification-item :item="notification" />
                            </template>
                        </div>
                    </transition-group>
                </vx-scroll-area>
            </template>
        </vx-dropdown>
    </div>
</template>

<script>
import NotificationItem from './NotificationItem.vue'
import NotificationGroupItem from './NotificationGroupItem.vue'
import { mapGetters } from 'vuex'
import VxScrollTrigger from '../VxScrollTrigger.vue'

export default {
    name: 'vx-notification-dropdown',
    components: {
        NotificationItem,
        NotificationGroupItem,
        VxScrollTrigger
    },
    props: {
        justify: {
            type: String,
            default: 'end'
        },
        align: {
            type: String,
            default: 'bottom'
        },
        showNotificationCounter: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    watch: {
        notifications: {
            handler: function (newV) {},
            immediate: true,
            deep: true
        }
    },
    computed: {
        ...mapGetters({
            notifications: 'notification/fetchAll'
        }),
        chipClass() {
            return this.showNotificationCounter ? 'count-chip' : 'no-count-chip'
        },

        hasNotifications() {
            return this.notifications.length >= 1
        },
        newNotificationCount() {
            if (this.notifications.length == 0) {
                return 0
            }
            return this.notifications.where((i) => !i.isRead).count()
        },
        hasNewNotification() {
            return !!this.newNotificationCount
        },

        notificationTitle() {
            return this.notifications.length > 0 ? 'Notification' : 'No Notification to show'
        }
    },
    methods: {
        isItemArray(notificationItem) {
            return Array.isArray(notificationItem)
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
.no-count-chip {
    margin: -30px 1px 0px 10px !important;
    min-height: 13px !important;
    min-width: 13px !important;
    padding: 0px !important;
    ::v-deep span {
        margin: 0px !important;
        font-size: smaller;
    }
}
.count-chip {
    margin: -30px 1px 0px 10px !important;
    min-height: 13px !important;
    min-width: 13px !important;
    padding: 0px !important;
    ::v-deep span {
        margin: 0px !important;
        font-size: smaller;
    }
}
.scroll-area {
    max-height: 400px;
    max-width: 300px;
    width: 300px;
}

.list-move,
.list-enter-active,
.list-leave-active {
    transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(50px);
}
.list-leave-active {
    position: absolute;
}
</style>
